// test1899
(1899 && 0);
